import React from 'react';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router';

// Components
import { TertiaryButton } from 'wg-fe-ui';

// Redux
import { useDispatch } from 'react-redux';
import { resetProductFactory } from '../../store/redux/slices/productFactorySlice';
import { mq } from '../../../../common/src/utils/styledComponentsUtils';

const SessionActiveHeader: React.FC<React.PropsWithChildren<unknown>> = ({
  ...otherProps
}) => {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const history = useHistory();

  const handleReset = () => {
    dispatch(resetProductFactory());
    history.go(0);
  };

  return (
    <Wrapper data-test-id="ProdFac_SessionActiveHeader" {...otherProps}>
      <p>{t('There is a session active')}</p>
      <TertiaryButton
        data-test-id="ProdFac_CompanySelection_NewSession"
        onClick={handleReset}
      >
        {t('New session')}
      </TertiaryButton>
    </Wrapper>
  );
};

const Wrapper = styled.div`
  z-index: 1;
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-bottom: 1px solid ${({ theme }) => theme.gray[50]};
  margin-left: 0;
  padding: 0 1.6rem;
  background: #fff;
  height: 6rem;
  max-width: 100vw;

  &,
  button {
    color: ${({ theme }) => theme.gray[400]};
  }

  ${mq.laptop} {
    border: none;
    /* Used to slightly overlap the toolbar */
    margin-left: -2rem;
    padding: 2rem 2rem 2rem 4.5rem;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.04), 0 0 2px rgba(0, 0, 0, 0.06),
      0 0 1px rgba(0, 0, 0, 0.04);
  }
`;

export default SessionActiveHeader;
